<template>
  <ul class="home-nav-box">
    <!-- 小程序中不显示 -->
    <li
      v-for="(item, index) in list"
      :key="index"
      @click="jump(item)"
      :style="{ width: item.width, backgroundColor: item.color }"
      :class="['nav-banner', item.name == '搜索' ? 'search' : '']"
    >
      <img
        :class="[item.name == '搜索' ? 'home-search' : 'icon']"
        :src="item.img"
        alt
      />
      <p>{{ item.name }}</p>
    </li>
  </ul>
</template>
<script>
export default {
  name: '',
  data() {
    return {
      list: [
        {
          name: '医学视频',
          img:
            'http://cdn.yxvzb.com/WEB/wx-master/images/svg/%E5%8C%BB%E5%AD%A6%E8%A7%86%E9%A2%91.svg',
          page: '/courseList',
          color: '#4388fd',
          width: '3.9rem'
        },
        {
          name: '精品课程',
          img:
            'http://cdn.yxvzb.com/WEB/wx-master/images/svg/%E7%B2%BE%E5%93%81%E8%AF%BE%E7%A8%8B.svg',
          color: '#7478fe',
          width: '3.4rem',
          href: 'http://wx.yxvzb.com/html/ess.html#/listCourse'
        },
        {
          name: '搜索',
          img: 'http://cdn.yxvzb.com/WEB/wx-master/images/pic/index_search.png',
          page: '/search',
          color: '#4361fd',
          width: '1.4rem'
        },
        {
          name: '学术专区',
          img:
            'http://cdn.yxvzb.com/WEB/wx-master/images/svg/%E5%AD%A6%E6%9C%AF%E4%B8%93%E5%8C%BA.svg',
          page: '/zoneList',
          color: '#4fabfe',
          width: '5.3rem'
        },
        {
          name: '职称题库',
          img:
            'http://cdn.yxvzb.com/WEB/wx-master/images/svg/%E8%81%8C%E7%A7%B0%E9%A2%98%E5%BA%93.svg',
          color: '#4388fd',
          width: '3.65rem',
          href: 'http://wx.yxvzb.com/html/zkzx.html'
        }
      ]
    };
  },
  methods: {
    jump(item) {
      let wxUserInfoObj = this.$api.getStorage('wxUserInfo');
      if (item.name == '头条') {
        sa.track(
          'BUTTON_READMORE',
          {
            eventType: 'yuedu',
            fromType: 'wx',
            client_id: wxUserInfoObj.id || wxUserInfoObj.wxOpenId,
            web_edition: 2
          },
          function() {}
        );
        this.$router.push({ path: item.page });
      } else if (item.name == '商城') {
        sa.track(
          'goods_shop',
          {
            pageUrl: location.href,
            client_id: wxUserInfoObj.id || wxUserInfoObj.wxOpenId,
            from: 'wx'
          },
          function() {
            location.href =
              '/html/newWechat.html?from=singlemessage&isappinstalled=0#/headlineDetail/6fd7a332-a1f8-4d66-8dd1-b3d5b66f5081?type=0&shareFlag=true';
          }
        );
      } else {
        if (item.page) {
          this.$router.push({ path: item.page });
        } else {
          window.location.href = item.href;
        }
      }
    }
  },
  computed: {},
  components: {},
  mounted() {}
};
</script>
<style lang="less" scoped>
// NAV 导航样式
.home-nav-box {
  padding: 0.35rem 0.4rem;
  position: relative;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  height: 3.89rem;
  color: #fff;
  font-size: 0.43rem;
  border-bottom: 0.19rem solid #f4f4f4;
  li {
    border-radius: 0.08rem;
    margin-bottom: 0.3rem;
    height: 1.44rem;
    padding: 0.24rem;
    position: relative;
    p {
      line-height: 1;
    }
    .icon {
      position: absolute;
      right: 0;
      height: 1rem;
    }
  }
  .search {
    padding: 0;
    text-align: center;
    p {
      margin-top: 0.05rem;
    }
  }
  li:nth-of-type(2),
  li:nth-of-type(3) {
    // margin-left: 0.19rem;
  }
  .nav-banner {
    background-size: 100% 100%;
  }
  .home-nav-content {
    margin: 0.1rem 0 0 0.19rem;
  }
  .home-search {
    width: 0.4rem;
  }
  .home-plus {
    margin-right: 0.19rem;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 0.37rem;
    height: 0.33rem;
    img {
      width: 100%;
    }
  }
  .home-nav-desc {
    margin-left: 0.19rem;
    font-size: 0.27rem;
  }
  .home-second {
    font-size: 0.32rem;
    color: #fffdfd;
  }
  .home-nav-one {
    margin: 0 !important;
    width: 1.75rem;
  }
  .active_0 {
    padding: 0 0 1rem 0.27rem;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: 3.53rem;
    height: 2.96rem;
    display: none;
  }
  .active_1 {
    width: 3.92rem;
    height: 1.39rem;
  }
  .active_2 {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background: #3d61fe;
    width: 1.36rem;
    height: 1.39rem;
  }
  .active_3 {
    position: absolute;
    bottom: 11%;
    right: 4%;
    width: 9rem;
    height: 1.39rem;
  }
  .active_4 {
    position: absolute;
    bottom: 53%;
    right: 4%;
    width: 3.3rem;
    height: 1.39rem;
  }
}
// 3.53rem
//2.96rem
//3.92rem
//1.39rem
// 1.36rem 1.39rem
// 2.65rem
</style>
